import { useState } from "react";
import Sidebar from "../components/Sidebar";
import MobileHeader from "../components/MobileHeader";
import { supabase } from "../supabase";

export default function Settings() {
  const [isMobile] = useState(window.innerWidth < 768);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChangePassword = async () => {
    setError("");
    setSuccess("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match");
      return;
    }
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) {
      setError(error.message);
    } else {
      setSuccess("Password updated successfully!");
      setNewPassword("");
      setConfirmPassword("");
    }
    setLoading(false);
  };

  const inputStyle = {
    width: "100%",
    border: "0.5px solid #e0e0e0",
    borderRadius: "8px",
    padding: "8px 12px",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
    color: "#111",
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8f8f8" }}>
      {!isMobile && <Sidebar />}

      <div style={{ flex: 1, minWidth: 0 }}>
        {isMobile && <MobileHeader title="Settings" />}

        {/* Top bar */}
        <div
          style={{
            background: "#fff",
            borderBottom: "0.5px solid #e8e8e8",
            padding: "12px 24px",
          }}
        >
          <div className="t-page-title">Settings</div>
        </div>

        <div
          style={{
            padding: isMobile ? "12px" : "20px 24px",
            maxWidth: "500px",
          }}
        >
          {/* Change password card */}
          <div
            style={{
              background: "#fff",
              border: "0.5px solid #e8e8e8",
              borderRadius: "12px",
              padding: "20px",
            }}
          >
            {/* Card title + subtitle */}
            <div className="t-name" style={{ marginBottom: "2px" }}>
              Change password
            </div>
            <div
              className="t-label"
              style={{ marginBottom: "20px", color: "#9ca3af" }}
            >
              Update your account password
            </div>

            {/* Error */}
            {error && (
              <div
                style={{
                  background: "#fcebeb",
                  borderRadius: "8px",
                  padding: "10px 14px",
                  marginBottom: "14px",
                }}
              >
                <span className="t-body" style={{ color: "#a32d2d" }}>
                  {error}
                </span>
              </div>
            )}

            {/* Success */}
            {success && (
              <div
                style={{
                  background: "#eaf3de",
                  borderRadius: "8px",
                  padding: "10px 14px",
                  marginBottom: "14px",
                }}
              >
                <span className="t-body" style={{ color: "#3b6d11" }}>
                  ✅ {success}
                </span>
              </div>
            )}

            {/* Fields */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "18px",
              }}
            >
              <div>
                <div className="t-label" style={{ marginBottom: "4px" }}>
                  New password
                </div>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  style={inputStyle}
                />
              </div>
              <div>
                <div className="t-label" style={{ marginBottom: "4px" }}>
                  Confirm new password
                </div>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  style={inputStyle}
                />
              </div>
            </div>

            <button
              onClick={handleChangePassword}
              disabled={loading}
              style={{
                background: "#3a9e5f",
                color: "#fff",
                fontSize: "12px",
                fontWeight: "500",
                letterSpacing: "-0.01em",
                padding: "8px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                opacity: loading ? 0.6 : 1,
              }}
            >
              {loading ? "Updating..." : "Update password"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
